import { render, staticRenderFns } from "./TgNotificationButton.vue?vue&type=template&id=8fb78d34&scoped=true"
import script from "./TgNotificationButton.vue?vue&type=script&lang=js"
export * from "./TgNotificationButton.vue?vue&type=script&lang=js"
import style0 from "./TgNotificationButton.vue?vue&type=style&index=0&id=8fb78d34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb78d34",
  null
  
)

export default component.exports